import { createFileRoute, Link } from '@tanstack/react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '@/lib/common/inputs/TextInput';
import { LoginProps, useAuth } from '@/lib/auth/hooks/useAuth';
import AuthFormStyling from '@/lib/auth/components/AuthFormStyling';
import { Button } from '@heroui/react';

export const Route = createFileRoute('/auth/login')({
    component: RouteComponent,
});

const schema = object().shape({
    email: string().required().email().label('Email'),
    password: string().required().min(8).label('Password'),
});

function RouteComponent() {
    const { login, mustConfirmEmail, userLoading, loginLoading } = useAuth();
    const f = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            email: '',
            password: '',
        },
        mode: 'onChange',
    });

    const onSubmit = (data: LoginProps) => {
        login(data);
    };

    return (
        <AuthFormStyling>
            <FormProvider {...f}>
                <form onSubmit={f.handleSubmit(onSubmit)}>
                    <div className='grid  gap-5'>
                        <span className='text-2xl font-bold'>Log in to Caddy Stats</span>
                        <TextInput name='email' label='Email' placeholder='email@example.com' type='text' />
                        <TextInput name='password' label='Password' placeholder='' type='password' />
                        {mustConfirmEmail && (
                            <div className='text-red-500'>
                                You must confirm your email address, we have resent you a confirmation email.
                            </div>
                        )}
                        <Button
                            type='submit'
                            disabled={userLoading || loginLoading}
                            color='primary'
                            isLoading={loginLoading}>
                            Log in
                        </Button>
                        <Link to='/auth/forgot-password'>
                            <Button className='btn-transparent w-full'>Forgot password</Button>
                        </Link>
                    </div>
                </form>
            </FormProvider>
        </AuthFormStyling>
    );
}
